import { html, ViewTemplate, repeat, ref } from '@microsoft/fast-element';
import { expandIcon } from '../../../../styles';
import type { SellerInterest } from './seller-interest';
import { VPPA_COLUMNS } from './column-config';
import { eventDetail } from '../../../../utils/formatting';

export const SellerInterestTemplate: ViewTemplate<SellerInterest> = html`
  <div class="seller-interest">
    <zero-tabs>
      <span slot="start" class="tab-title">Seller Interest</span>

      <div slot="end" class="end-content">
        <span class="filter-rfq-title">Filter by RFQ</span>
        <cascade-multi-select
          name="rfqs"
          class="card-version"
          ${ref('rfqsElement')}
          @registeredClickCallback="${(x, c) => x.rfqSelectionChanged(eventDetail(c))}"
        ></cascade-multi-select>
        <zero-button
          style="display: ${(x) => (x.isExpanded ? 'none' : '')}"
          slot="buttons"
          appearance="tab-primary"
          @click=${(x) => x.expandView(true)}
        >
          ${expandIcon('end')} Expand Contracts
        </zero-button>
        <zero-button
          style="display: ${(x) => (x.isExpanded ? '' : 'none')}"
          class="rotate-icon"
          slot="buttons"
          appearance="tab-primary"
          @click=${(x) => x.expandView(false)}
        >
          ${expandIcon('start')} Contract Contracts
        </zero-button>
      </div>
      <tab-buttons slot="end">

        <zero-button
          class="buttons-padding"
          slot="buttons"
          appearance="tab-primary"
          @click=${(x) => x.downloadGridCsv()}
        >
          Download
        </zero-button>
        
    </zero-tabs>
    <div class="seller-interest-criteria">
      <span class="light-gray-title">Contracts matching this criteria</span>
    </div>
    <div class="seller-interest-data">
      <div class="seller-interest-grid">
        <zero-grid-pro
          class="grid-styles"
          only-template-col-defs
          sideBar=""
          rowSelection="single"
          @onGridReady="${(x) => x.onGridReady()}"
          ${ref('sellerInterestVppaGrid')}
        >
          ${repeat(
            (x) => VPPA_COLUMNS(x),
            html`
              <grid-pro-column :definition="${(x) => x}"></grid-pro-column>
            `
          )}
        </zero-grid-pro>
        \`
      </div>
    </div>
  </div>
`;
